import { render, staticRenderFns } from "./ObjectsListColumn.vue?vue&type=template&id=9921a9f4&scoped=true&"
import script from "./ObjectsListColumn.vue?vue&type=script&lang=js&"
export * from "./ObjectsListColumn.vue?vue&type=script&lang=js&"
import style0 from "./ObjectsListColumn.vue?vue&type=style&index=0&id=9921a9f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9921a9f4",
  null
  
)

export default component.exports